import { useSelector } from "react-redux";

import type { RootState } from "../store";
import { useOrganizationMembership } from "./useOrganizationMembership";

export interface CreatorModeGate {
  /** The shortcut toggle itself (off on every reload). */
  enabled: boolean;
  /** Whether to show create-dataset / create-model options: creator mode on, or a full Admin. */
  canCreate: boolean;
  /** False until the user's groups are read, so pages can wait before redirecting. */
  isResolved: boolean;
}

// Create options only — editing stays with the owner (or Admin) whether creator mode is on or not.
export const useCreatorMode = (): CreatorModeGate => {
  const enabled = useSelector((state: RootState) => state.creatorMode.enabled);
  const { isFullAdmin, isResolved } = useOrganizationMembership();
  return { enabled, canCreate: enabled || isFullAdmin, isResolved };
};

export default useCreatorMode;
